import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Subscription } from "@/savaradio/common"
export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>

const initialState: { value?: Subscription[], isLoading: IsLoading } = { isLoading: initialLoading }

const subscriptionSlice = createSlice({
  name: "subscription_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Subscription>) => {
      if (!state.value) state.value = [action.payload]
      if (
        state.value &&
        !state.value.some(item => item._id === action.payload._id)
      ) state.value = [...state.value, action.payload]
    },
    reset: (state, action: PayloadAction<Subscription[] | undefined>) => {
      state.value = action.payload
    },
    merge: (state, action: PayloadAction<Subscription>) => {
      if (state.value) state.value = state.value.map(subscription => {
        if (subscription._id === action.payload._id) return action.payload
        return subscription
      })
    },
    pop: (state, action: PayloadAction<Subscription>) => {
      if (state.value) state.value = state.value.filter(subscription => subscription._id !== action.payload._id)
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, reset, pop, merge, setLoading } = subscriptionSlice.actions
export const subscription_slice = subscriptionSlice.reducer